import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { userById } from "../actions/userById";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";
import { getDisplayName } from "../utils/displayName";
const Realtor = ({ realtor }) => {
  const [poster, setPoster] = useState(null);
  useEffect(() => {
    userById(realtor?.realtor_id, { setPoster });
  }, [realtor]);
  return (
    <>
      {realtor && realtor["realtor_id"] && (
        <>
          <h1 className="font-bold pt-8 mb-2">
            Selected realtor. Please contact this property's preferred realtor
            by calling {poster?.phone_number}
          </h1>
          <Link
            to={`/user/${realtor["realtor_id"]}`}
            className="border-2 rounded-10 py-2 px-8 flex items-center justify-between hover:scale-105 hover:cursor-pointer transition-all w-[300px]"
          >
            <img
              className="h-[60px] w-[60px] object-cover rounded-full"
              src={
                realtor["realtor_picture"]
                  ? cloudinaryUrl(realtor["realtor_picture"])
                  : "/error.png"
              }
              alt="realtor"
            />
            <div className="w-max text-center">
              <h1 className="text-19">{getDisplayName(poster)}</h1>
              <p className="text-blue-500">{poster?.brokerage_name}</p>
              <p className="text-sm font-medium text-slate-700">
                {poster?.class_type}
              </p>
              {poster?.email_address && (
                <p className="text-xs text-slate-600 mt-1">
                  <a
                    href={`mailto:${poster.email_address}`}
                    className="hover:underline"
                  >
                    {poster.email_address}
                  </a>
                </p>
              )}
              {poster?.phone_number && (
                <p className="text-xs text-slate-600">
                  <a
                    href={`tel:${poster.phone_number}`}
                    className="hover:underline"
                  >
                    {poster.phone_number}
                  </a>
                </p>
              )}
            </div>
          </Link>
        </>
      )}
    </>
  );
};

export default Realtor;
